import { buildChangeFinancialYearEndVariables } from '../../../preset/mappers/changeFinancialYearEndMapper';

export interface CfyeFormModel {
  companyName: string;
  companyRegistrationNo: string;
  currentFyeDate: string;
  newFyeDate: string;
  newFinancialPeriodMonths: string;
  nextFyStartDate: string;
  nextFyEndDate: string;
  cspName: string;
  resolutionDate: string;
}

export function createEmptyCfyeForm(): CfyeFormModel {
  return {
    companyName: '',
    companyRegistrationNo: '',
    currentFyeDate: '',
    newFyeDate: '',
    newFinancialPeriodMonths: '',
    nextFyStartDate: '',
    nextFyEndDate: '',
    cspName: '',
    resolutionDate: '',
  };
}

export function toTemplateVariables(model: CfyeFormModel): Record<string, any> {
  return buildChangeFinancialYearEndVariables({
    company_name: model.companyName,
    company_registration_no: model.companyRegistrationNo,
    current_fye_date: model.currentFyeDate,
    new_fye_date: model.newFyeDate,
    new_financial_period_months: model.newFinancialPeriodMonths,
    next_fy_start_date: model.nextFyStartDate,
    next_fy_end_date: model.nextFyEndDate,
    csp_name: model.cspName,
    resolution_date: model.resolutionDate,
    Signers: '',
  });
}

function trimFlat(v: unknown): string {
  return v === null || v === undefined ? '' : String(v).trim();
}

/**
 * 문서/태스크 mergedFlat 의 snake_case·camelCase → DR 템플릿 JSON.
 * L_TASK_EFILING_DATA.FORM_DATA 에 넣을 때 PreSet 화면의 toTemplateVariables() 와 동일 구조.
 */
export function cfyeMergedFlatToTemplateJson(
  mergedFlat: Record<string, any> | null | undefined,
): Record<string, any> {
  const f = mergedFlat && typeof mergedFlat === 'object' ? mergedFlat : {};
  const model: CfyeFormModel = {
    companyName: trimFlat(f.company_name ?? f.companyName),
    companyRegistrationNo: trimFlat(f.company_registration_no ?? f.companyRegistrationNo),
    currentFyeDate: trimFlat(f.current_fye_date ?? f.currentFyeDate),
    newFyeDate: trimFlat(f.new_fye_date ?? f.newFyeDate),
    newFinancialPeriodMonths: trimFlat(f.new_financial_period_months ?? f.newFinancialPeriodMonths),
    nextFyStartDate: trimFlat(f.next_fy_start_date ?? f.nextFyStartDate),
    nextFyEndDate: trimFlat(f.next_fy_end_date ?? f.nextFyEndDate),
    cspName: trimFlat(f.csp_name ?? f.cspName),
    resolutionDate: trimFlat(f.resolution_date ?? f.resolutionDate),
  };
  return toTemplateVariables(model);
}

export function isCfyeFormComplete(m: CfyeFormModel): boolean {
  return [
    m.companyName,
    m.companyRegistrationNo,
    m.currentFyeDate,
    m.newFyeDate,
    m.newFinancialPeriodMonths,
    m.nextFyStartDate,
    m.nextFyEndDate,
    m.cspName,
    m.resolutionDate,
  ].every((v) => String(v || '').trim().length > 0);
}
